// AuditTable component styles
export const TABLE_STYLES = {
  container: {
    overflowY: "auto",
    overflowX: "hidden",
    flex: "1",
    width: "100%",
    pb: "20px",
    css: {
      '&::-webkit-scrollbar': { width: '3px' },
      '&::-webkit-scrollbar-track': { background: 'transparent' },
      '&::-webkit-scrollbar-thumb': { background: '#e2e8f0', borderRadius: '2px' },
      '&::-webkit-scrollbar-thumb:hover': { background: '#cbd5e0' },
      scrollbarWidth: 'thin',
      scrollbarColor: '#e2e8f0 transparent'
    }
  },
  table: {
    variant: "simple",
    width: "100%",
    size: "sm"
  },
  thead: {
    bg: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
    position: "relative",
    _before: {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      bg: "linear-gradient(90deg, rgba(59, 130, 246, 0.05) 0%, rgba(147, 51, 234, 0.05) 100%)",
      pointerEvents: "none"
    }
  },
  th: {
    fontSize: "13px",
    fontWeight: "800",
    color: "gray.800",
    textTransform: "uppercase",
    letterSpacing: "wider",
    py: 5,
    px: 6,
    borderBottom: "3px solid",
    borderColor: "blue.500",
    position: "relative",
    _hover: {
      bg: "rgba(59, 130, 246, 0.1)",
      color: "blue.800",
      cursor: "pointer"
    },
    transition: "all 0.3s ease",
    _after: {
      content: '""',
      position: "absolute",
      bottom: "-3px",
      left: "50%",
      transform: "translateX(-50%) scaleX(0)",
      width: "80%",
      height: "3px",
      bg: "linear-gradient(90deg, #3b82f6, #8b5cf6)",
      borderRadius: "full",
      transition: "transform 0.3s ease"
    },
    _hover_after: {
      transform: "translateX(-50%) scaleX(1)"
    }
  },
  tr: {
    _hover: {
      cursor: "pointer",
      bg: "blue.50",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
    },
    transition: "all 0.2s ease",
    borderBottom: "1px solid",
    borderColor: "gray.100"
  },
  td: {
    fontSize: "14px",
    fontWeight: "400",
    color: "gray.800",
    whiteSpace: "normal",
    py: 4,
    px: 6,
    borderBottom: "none"
  },
  loadingBox: {
    display: "flex",
    mt: "50px",
    flexDirection: "column",
    alignItems: "center",
    gap: 3
  },
  loadingTd: {
    textAlign: "center",
    py: 12,
    px: 6
  }
};
